if (!customElements.get('nasaem-variant-picker')) {
  customElements.define('nasaem-variant-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.section = this.closest('.nasaem-pdp');
      this.form = this.closest('form');
      this.buttons = [...this.form.querySelectorAll('[data-reef-pdp-actions] button')];
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.updateVariant());
      });
    }

    disconnectedCallback() {
      this.request?.abort();
    }

    async updateVariant() {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      const variantId = this.querySelector('input:checked').value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      const sectionUrl = new URL(url);
      sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');
      this.buttons.forEach((button) => { button.disabled = true; });
      this.form.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', '');

      try {
        // Let Shopify render prices, discounts and availability in the current market.
        const response = await fetch(sectionUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Variant could not be loaded');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        const next = html.getElementById(this.section.id);
        if (!next || next.querySelector('[name="id"]:checked')?.value !== variantId) {
          throw new Error('Variant response did not match the selection');
        }

        const price = next.querySelector('.nasaem-pdp__price');
        this.section.querySelector('.nasaem-pdp__price').innerHTML = price.innerHTML;
        // Keep bundle controls and their listeners; update only the quoted amounts.
        const nextBundles = [...next.querySelectorAll('.nasaem-bundle__save')];
        this.section.querySelectorAll('.nasaem-bundle__save').forEach((node, index) => {
          if (nextBundles[index]) node.innerHTML = nextBundles[index].innerHTML;
        });
        const image = next.querySelector('[data-nasaem-stage] img');
        const currentImage = this.section.querySelector('[data-nasaem-stage] img');
        if (image && currentImage) {
          currentImage.src = image.src;
          currentImage.alt = image.alt;
          currentImage.removeAttribute('srcset');
          this.section.querySelectorAll('[data-nasaem-thumb]').forEach((thumb) => {
            thumb.setAttribute('aria-pressed', String(thumb.dataset.src === image.getAttribute('src')));
          });
        }
        this.buttons.forEach((button) => {
          const selector = button.hasAttribute('data-reef-buy-now') ? '[data-reef-buy-now]' : '[data-reef-add]';
          const nextButton = next.querySelector(selector);
          button.disabled = nextButton.disabled;
          button.removeAttribute('aria-disabled');
          button.querySelector('span').textContent = nextButton.querySelector('span').textContent;
        });
        this.form.closest('product-form').error = false;

        const sticky = document.querySelector('[data-reef-sticky-atc]');
        if (sticky) {
          const stickyPrice = price.cloneNode(true);
          stickyPrice.querySelector('.reef-card-flag')?.remove();
          sticky.querySelector('[data-reef-sticky-price]').innerHTML = stickyPrice.innerHTML;
          sticky.querySelector('[data-reef-sticky-label]').textContent = next.querySelector('[data-reef-add]').disabled
            ? 'نفدت الكمية' : this.dataset.stickyLabel;
          const stickyImage = sticky.querySelector('[data-reef-sticky-image]');
          if (image && stickyImage) stickyImage.src = image.src;
        }
        history.replaceState(history.state, '', url);
        this.removeAttribute('aria-busy');
        try { window.bucksCC?.reConvert?.(); } catch { /* Currency app is optional. */ }
      } catch (error) {
        if (error.name === 'AbortError') return;
        // A full render is a safe fallback if the section request fails.
        window.location.assign(url.href);
      }
    }
  });
}
